var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ListingGrid',{attrs:{"column":_vm.auditColumn,"endpoint":this.$route.path + "/revisions?fetchChanges=true","dataObject":"auditDtoes","hideCreateButton":true,"redirectUrl":this.$route.path + this.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }